<template>

    <div class="container">

        <div class="my-4">
            <inertia-link :href="route('messages.index')">
                <i class="bi bi-x-lg"></i>
                {{ __('Abbrechen') }}
            </inertia-link>
        </div>

        <div class="my-4">
            <h1>{{ __('Nachricht verfassen') }}</h1>
        </div>

        <message-form :emoticons="emoticons" />

    </div>

</template>


<script>

    import MessageForm from './MessageForm';

    export default {
        props: [
            'emoticons',
        ],
        data() {
            return {

            }
        },
        components: {
            MessageForm
        },
        methods: {

        },
    }
</script>